/**
 * El botón "Actualizar" del muro no puede dejar a nadie atrapado.
 *
 * `Linking.openURL` rechaza cuando el OS se niega a abrir una URL (visto en
 * producción: TAGO-MOBILE-5E — tago@1.0.4, "Unable to open URL:
 * https://apps.apple.com/sv/app/id6797718483"). En el muro de actualización esa
 * promesa era un `void` sin catch: el rechazo llegaba a Sentry Y el botón no
 * hacía nada — en un build viejo, donde el muro es la única pantalla, el
 * usuario quedaba encerrado sin saber por qué.
 *
 * El respaldo correcto es el esquema nativo de cada tienda, que no depende del
 * manejador de https del navegador del sistema: `itms-apps://` en iOS y
 * `market://` en Android. Esta función es pura para fijarla con un test.
 */
export function nativeStoreSchemeUrl(storeUrl: string): string | null {
  const apple = storeUrl.match(/^https:\/\/apps\.apple\.com\/([A-Za-z]{2})\/app\/(id\d+)/)
  if (apple) return `itms-apps://apps.apple.com/${apple[1]}/app/${apple[2]}`

  const play = storeUrl.match(
    /^https:\/\/play\.google\.com\/store\/apps\/details\?id=([A-Za-z0-9_.]+)/,
  )
  if (play) return `market://details?id=${play[1]}`

  return null
}
